
module.exports = function()
{
    this.type = "";
    this.message = null;
    this.toastId = "";
}